export function delayP(ms) {
    return new Promise((resolve) => {
        setTimeout(resolve, ms);
    });
}
export function checkQueryEqual(a, b) {
    if (Object.keys(a).length !== Object.keys(b).length) {
        return false;
    }
    if (Object.keys(a).length === 0) {
        return true;
    }
    return Object.keys(a).every((key) => {
        return a[key] === b[key];
    });
}
export const pushState = (path, pageTitle, query) => {
    document.title = pageTitle;
    const searchParams = new URLSearchParams();
    for (const key in query) {
        searchParams.set(key, query[key]);
    }
    const search = searchParams.toString();
    window.history.pushState(query, pageTitle, `${path}${search ? `?${search}` : ''}`);
};
